import { render, staticRenderFns } from "./LayoutProspectLink.vue?vue&type=template&id=99ce865e"
import script from "./LayoutProspectLink.vue?vue&type=script&lang=js"
export * from "./LayoutProspectLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports